import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

import AmenityOverview from './AmenityOverview'
import AmenityReservationCalendar from './AmenityReservationCalendar/AmenityReservationCalendar'

const AmenityDetailsSidebar = ({ amenity }) => {
  const [underReservation, setUnderReservation] = useState(null)

  useEffect(() => {
    setUnderReservation(null)
  }, [amenity])

  const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY)

  return (
    <div className="client-reservations-sidebar">
      {!underReservation ? (
        <AmenityOverview
          amenity={amenity}
          preReservation={(selectedAmenity) => setUnderReservation(selectedAmenity)}
        />
      ) : (
        <Elements stripe={stripePromise}>
          <AmenityReservationCalendar
            amenity={amenity}
            cancelReservationView={() => setUnderReservation(null)}
          />
        </Elements>
      )}
    </div>
  )
}

AmenityDetailsSidebar.propTypes = {
  amenity: PropTypes.object,
}

export default AmenityDetailsSidebar
